function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9997 20.3483C16.5726 20.3483 20.2797 16.6412 20.2797 12.0683C20.2797 7.49541 16.5726 3.78833 11.9997 3.78833C7.42681 3.78833 3.71973 7.49541 3.71973 12.0683C3.71973 16.6412 7.42681 20.3483 11.9997 20.3483Z",
  fill: "#DF0024",
  className: "shieldCheckFillPrimaryBackground"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7797 12.0683C19.7797 16.3651 16.2965 19.8483 11.9997 19.8483V20.8483C16.8488 20.8483 20.7797 16.9174 20.7797 12.0683H19.7797ZM11.9997 19.8483C7.70295 19.8483 4.21973 16.3651 4.21973 12.0683H3.21973C3.21973 16.9174 7.15067 20.8483 11.9997 20.8483V19.8483ZM4.21973 12.0683C4.21973 7.77155 7.70295 4.28833 11.9997 4.28833V3.28833C7.15067 3.28833 3.21973 7.21927 3.21973 12.0683H4.21973ZM11.9997 4.28833C16.2965 4.28833 19.7797 7.77155 19.7797 12.0683H20.7797C20.7797 7.21927 16.8488 3.28833 11.9997 3.28833V4.28833Z",
  fill: "#DF0024",
  className: "shieldCheckFillPrimaryBackground"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8.1377 12.1882L10.6352 14.6857C10.6352 14.6857 13.8258 11.4951 15.8702 9.45068",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgShieldCheckFillPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckFillPrimary);
export default __webpack_public_path__ + "static/media/shield-check-fill-primary.725adea1.svg";
export { ForwardRef as ReactComponent };